import { render, staticRenderFns } from "./mediaSpec.vue?vue&type=template&id=509fc3e4&"
import script from "./mediaSpec.vue?vue&type=script&lang=js&"
export * from "./mediaSpec.vue?vue&type=script&lang=js&"
import style0 from "./mediaSpec.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports